<template>
    <div class="login-page">
        <transition name="pzz" mode="out-in">
            <component :is="componentId" @changeComponent='changeComponent'></component>
        </transition>
    </div>
</template>

<script>

const Login = () => import('./login')
const ForgetPassword = () => import('./forgetPassword')

export default {
    name:'LoginWrap',
    data() {
        return {
            componentId: Login
        }
    },
    methods: {
        changeComponent(){
            this.componentId === Login ? this.componentId = ForgetPassword : this.componentId = Login
        }
    }
}
</script>

<style lang="scss" scoped>
    .login-page {
        height:100%;
        width:100%;
    }
</style>
